import { tv } from 'tailwind-variants'

export const publicityVariants = tv({
  slots: {
    container: 'flex min-h-screen w-full flex-col items-center justify-center bg-white px-deca py-deca',
    logo: 'mb-deca h-[60px] w-auto max-w-full object-contain',
    stack: 'flex max-w-md flex-col items-center gap-y-deca text-center',
    title: 'text-h2 font-bold text-secondary-xdark',
    description: 'text-base text-medium',
    cta: 'min-w-[240px]',
    linkButton: 'text-medium underline-offset-2 hover:underline'
  }
})
